import i18next from 'i18next';
import jqueryI18next from 'jquery-i18next';

import enTranslation from '../assets/locales/en/translation.json';
import cnTranslation from '../assets/locales/cn/translation.json';

function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
}

const DEFAULT_LANG = 'en';
const LANG_STORAGE_KEY = 'i18nextLng';
const resources = {
    en: { translation: enTranslation },
    cn: { translation: cnTranslation },
};

if (!localStorage.getItem(LANG_STORAGE_KEY)) {
    const langInUrl = getQueryParam('lng');
    localStorage.setItem(LANG_STORAGE_KEY, langInUrl || DEFAULT_LANG);
}

const currentLanguage = localStorage.getItem(LANG_STORAGE_KEY) || DEFAULT_LANG;

i18next.init(
    {
        debug: false,
        lng: currentLanguage,
        fallbackLng: DEFAULT_LANG,
        resources,
    },
    () => {
        jqueryI18next.init(i18next, $);
        $('body').localize();
    }
);

$('#navbarLangSelector > a').on('click', function onLanguageClick() {
    localStorage.setItem(LANG_STORAGE_KEY, this.getAttribute('value'));
    window.location.reload();
});
